import { type Allergen } from '@sg/graphql-schema';

import { type AllergenTypes } from '../setup/types';

// ─────────────────────────────────────────────────────────────────────────────

export function sortPreferencesByName(preferences: AllergenTypes) {
  const preferencesNames = Object.keys(preferences);
  const sortedPreferences = [...preferencesNames].sort(compareAlphabetically);

  return sortedPreferences as Allergen[];
}

// ─────────────────────────────────────────────────────────────────────────────

function compareAlphabetically(preference: string, nextPreference: string) {
  return preference.localeCompare(nextPreference);
}
